module.exports = __webpack_public_path__ + "img/mail-logo.8ac57d90.png";